import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FlujoVentaPaso } from '../../../../_models/flujo-venta-paso';
import { NavService } from '../../../../_services/_nav.service';
import { ControlService } from '../../../../_services/control.service';
import { Control } from '../../../../_models/control';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FlujoVentaPasoComplementarioControlService } from '../../../../_services/flujo-venta-paso-complementario-control.service';
import { FlujoVentaPasoComplementarioControl } from '../../../../_models/flujo-venta-paso-complementario-control';

@Component( {
  selector: 'app-flujo-venta-complementario-adjunto',
  templateUrl: 'flujo-venta-complementario-adjunto.component.html'
} )

export class FlujoVentaComplementarioAdjuntoComponent implements OnInit {

  @Input() fluVentaPaso: FlujoVentaPaso;
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter<boolean>();
  lisControlesTodos: Control[] = [];
  lisControles: SelectItem[] = [];
  lisFlujoComplementarioControl: FlujoVentaPasoComplementarioControl[] = [];
  lisFlujoComplementarioControlTodos: FlujoVentaPasoComplementarioControl[] = [];
  cargando = true;
  formulario: FormGroup;
  submitted = false;
  columnas: any[] = [];

  constructor( private navService: NavService,
               private fb: FormBuilder,
               private conService: ConfirmationService,
               private fluVentaPasoComplementarioControlService: FlujoVentaPasoComplementarioControlService,
               private conControlService: ControlService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreControl', header: this.navService.buscarMensaje( 'FLUJOVENTACOMPLEMENTARIO.LBL_CONTROL' ), sort: false },
      { field: 'indicadorObligatorio', header: this.navService.buscarMensaje( 'FLUJOVENTACOMPLEMENTARIO.LBL_OBLIGATORIO' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    forkJoin( this.conControlService.listadoHabilitados(),
      this.fluVentaPasoComplementarioControlService.listadoPorIdFlujoPaso( this.fluVentaPaso.idFlujoVentaPaso ) ).subscribe( ( [ controles, lisFlujoControl ] ) => {
      this.lisControlesTodos = controles;
      this.lisFlujoComplementarioControlTodos = lisFlujoControl;
      this.cargarListado();
      this.cargarFormulario();
      this.cargarControles();
      this.cargando = false;
    } );
  }

  cargarListado() {
    this.lisFlujoComplementarioControl = this.lisFlujoComplementarioControlTodos.filter( x => x.indicadorHabilitado );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idFlujoVentaPasoComplementarioControl: [ null ],
      idFlujoVentaPaso: [ this.fluVentaPaso.idFlujoVentaPaso, [ Validators.required ] ],
      idControl: [ null, [ Validators.required ] ],
      indicadorObligatorio: [ false ],
      indicadorHabilitado: [ true ],
    } );
  }

  cargarControles() {
    this.lisControles = [];
    this.lisControlesTodos.forEach( e => {
      if ( !this.lisFlujoComplementarioControl.find( x => x.idControl === e.idControl ) ) {
        this.lisControles.push( { label: e.nombre, value: e.idControl } );
      }
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.formulario.valid ) {
      return;
    }
    this.cargando = true;
    const registro = this.formulario.value;
    const existe = this.lisFlujoComplementarioControlTodos.find( x => x.idControl === registro.idControl );
    if ( existe && !existe.indicadorHabilitado ) {
      existe.indicadorObligatorio = registro.indicadorObligatorio;
      existe.indicadorHabilitado = true;
      this.fluVentaPasoComplementarioControlService.actualizar( existe ).subscribe( r => {
        this.reiniciar();
      } );
    } else if ( !existe ) {
      this.fluVentaPasoComplementarioControlService.crear( registro ).subscribe( r => {
        registro.idFlujoVentaPasoComplementarioControl = r.idFlujoVentaPasoComplementarioControl;
        const control = this.lisControles.find( x => x.value === registro.idControl );
        if ( control ) {
          registro.nombreControl = control.label;
        }
        this.lisFlujoComplementarioControlTodos.push( registro );
        this.reiniciar();
      } );
    } else {
      this.navService.setMesage( 0, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_ATENCION' ),
        detail: this.navService.buscarMensaje( 'MSG_YAEXISTEELREGISTRO' )
      } );
      this.cargando = false;
    }
  }

  get f() {
    return this.formulario.controls;
  }

  inhablitar( registro: FlujoVentaPasoComplementarioControl ) {
    this.conService.confirm( {
      message: this.navService.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: `complementario`,
      accept: () => {
        this.cargando = true;
        registro.indicadorHabilitado = false;
        this.fluVentaPasoComplementarioControlService.actualizar( registro ).subscribe( r => {
          this.navService.setMesage( 2 );
          this.cargarListado();
          this.cargarControles();
          this.cargando = false;
        } );
      }
    } );
  }

  reiniciar() {
    this.cargarListado();
    this.cargarControles();
    this.reiniciarForm();
    this.navService.setMesage( 1 );
    this.cargando = false;
  }

  reiniciarForm() {
    this.submitted = false;
    this.formulario.markAsPristine();
    this.cargarFormulario();
  }

  salir() {
    this.dismiss.emit( true );
  }

}
